import {useNavigate}    from "react-router-dom"
import '../stylesheets/Navbar.css'
import React            from "react"
import {AppBar, Box, CssBaseline, Toolbar, useTheme} from "@mui/material"
import {alpha}          from "@mui/material/styles"
import BrandMark        from "./BrandMark"
import NavMenuButton    from "./NavMenuButton"
import TutorStylePicker from "./app/TutorStylePicker"

const Navbar = React.forwardRef((
	{currentTheme, toggleTheme }, ref
) => {

	const adminSession = localStorage.getItem('admin_session')
	const navigate = useNavigate()
	const theme = useTheme()

	/*
	 * A frosted bar below md (161).
	 *
	 * The AppBar is position:fixed and has always been transparent, so page content scrolls
	 * underneath it. On a narrow screen there is no gutter for it to scroll through — topic rows and
	 * headings pass directly behind the brand mark and the hamburger, and both become unreadable for
	 * the length of the scroll.
	 *
	 * A tint alone would not fix it: at any alpha low enough to still read as a bar rather than a
	 * block, text behind it still shows through. The blur is what actually separates the two layers,
	 * and the tint is what keeps the blur from looking like a smear.
	 *
	 * Transparent from md up, unchanged — there the content column is narrower than the window, so
	 * what passes behind the bar is page background.
	 *
	 * The impersonation red still wins outright. It is a warning, it is opaque, and it must not be
	 * softened into a tint.
	 */
	const frosted = {
		background: {
			xs: alpha(theme.palette.background.default, 0.85),
			md: 'transparent',
		},
		backdropFilter: {xs: 'blur(12px)', md: 'none'},
		// Safari, including iOS, still needs the prefix
		WebkitBackdropFilter: {xs: 'blur(12px)', md: 'none'},
		borderBottom: {xs: `1px solid ${theme.custom.border.color}`, md: 'none'},
	}

	return (
		<>
			<AppBar key={"appbar"}
			        ref={ref} position={"fixed"} elevation={0} color="transparent"
			        sx={adminSession ? {background: 'red'} : frosted}>
				<CssBaseline/>
				<Toolbar>
					{/* shared with study mode so the mark doesn't shift between screens (081) */}
					<BrandMark onClick={() => navigate('/')}/>
					<Box className={"nav-menu-container"}>
						<Box className={"nav-menu-left"}>

						</Box>
					</Box>
					<Box className={"account-menu-container"} sx={{display: 'flex', alignItems: 'center'}}>
						{/*
						  * Tutor Style, to the RIGHT of the hamburger and on every page (170). It was
						  * in the dashboard header, which meant the one setting a student changes
						  * mid-study was only reachable from the screen they had just left. It renders
						  * nothing at all when signed out or still loading, so it cannot shift the
						  * hamburger around on a public page.
						  */}
						<TutorStylePicker compact/>
						{/* the hamburger and its menu live in NavMenuButton so study mode can
						    render the same control rather than a copy of it (080) */}
						<NavMenuButton toggleTheme={toggleTheme}/>
					</Box>

				</Toolbar>
			</AppBar>
			<Toolbar key={"tbar"} className="navbar-background"/> {/* Empty Toolbar to push content down */}
		</>
	)
})

export default Navbar
